import os from "os";
import pino from "pino";
export const createLogger = (loggerOptions) => {
    return pino({
        // guard against os module so this can be used in browser
        base: "hostname" in os ? { hostname: os.hostname } : undefined,
        formatters: {
            // by default pino logs with an integer log level, e.g. 30, 50. Use the level formatted here to override this with
            // a string e.g. "error", "warn", "info", "debug".
            level(level) {
                return { level };
            },
        },
        ...loggerOptions,
    });
};
export const createLoggerOrChild = ({ logger, name, }) => {
    return logger ? logger.child({ name }) : createLogger({ name });
};
